module.exports = __webpack_public_path__ + "img/isdk.ff958411.png";